import type { SVGProps } from 'react';

import './style.css';

interface EternoSpinnerProps extends SVGProps<SVGSVGElement> {}

const PATH_D =
    'M107.668 26.853C130.947 4.69723 145.584 2.66457 165.102 6.62825C175.063 8.6513 198.748 20.0437 193.157 48.8057C188.732 71.5713 158.697 70.4358 144.873 67.0995C136.029 64.9652 117.833 57.5407 93.5386 42.1996C74.2248 30.0037 56.1308 12.1658 32.5478 13.0311C10.3876 13.8442 5 32.8494 5 40.5734C5 52.871 12.5219 68.2174 33.1575 69.8436C54.911 71.5577 73.5129 58.664 76.8677 56.6314';

const EternoSpinner = ({ className, style, ...props }: EternoSpinnerProps = {}) => (
    <svg
        {...props}
        className={className ? `eterno-spinner ${className}` : 'eterno-spinner'}
        style={style}
        viewBox="-6 -6 211 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path className="spinner-bg" d={PATH_D} strokeWidth="11" strokeLinecap="round" />
        <path
            className="spinner-trail"
            d={PATH_D}
            pathLength="100"
            stroke="#2e2e2e"
            strokeWidth="11"
            strokeLinecap="round"
            strokeDasharray="30 70"
            strokeDashoffset="0"
        />
    </svg>
);

export default EternoSpinner;
